module.exports = __webpack_public_path__ + "img/vu-logo-with-words1.7c2c0f7a.png";